module.exports = __webpack_public_path__ + "static/media/sn_ab_bb3.9cbf9746.jpg";